export default function loadSprite() {
  var ajax = new XMLHttpRequest();
  ajax.open('GET', './img/sprite.svg', true);
  ajax.send(null);
  ajax.onload = function () {
    if (this.status === 200) {
      var div = document.createElement('div');
      div.setAttribute('id', 'svg-global');
      div.innerHTML = ajax.responseText;
      document.body.insertBefore(div, document.body.childNodes[0]);
    } else {
      console.error('Sprite: %d %s', this.status, this.statusText);
    }
  }
}
